"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adapter_1 = __importDefault(require("@flatfile/adapter"));
var react_1 = __importStar(require("react"));
var FlatfileButton = function (_a) {
    var settings = _a.settings, licenseKey = _a.licenseKey, customer = _a.customer, onInteractionEvent = _a.onInteractionEvent, onBeforeFetch = _a.onBeforeFetch, onCancel = _a.onCancel, onData = _a.onData, onRecordChange = _a.onRecordChange, onRecordInit = _a.onRecordInit, fieldHooks = _a.fieldHooks, children = _a.children, render = _a.render, source = _a.source, mountUrl = _a.mountUrl, _b = _a.preload, preload = _b === void 0 ? true : _b, props = __rest(_a, ["settings", "licenseKey", "customer", "onInteractionEvent", "onBeforeFetch", "onCancel", "onData", "onRecordChange", "onRecordInit", "fieldHooks", "children", "render", "source", "mountUrl", "preload"]);
    var importerRef = react_1.useRef();
    var _c = react_1.useState(false), loaded = _c[0], setLoaded = _c[1];
    var loadImporter = function () {
        if (importerRef.current) {
            return;
        }
        if (mountUrl) {
            adapter_1.default.setMountUrl(mountUrl);
        }
        var tempImporter = new adapter_1.default(licenseKey, settings, customer);
        if (fieldHooks) {
            for (var key in fieldHooks) {
                tempImporter.registerFieldHook(key, fieldHooks[key]);
            }
        }
        if (onBeforeFetch) {
            tempImporter.registerBeforeFetchCallback(onBeforeFetch);
        }
        if (onInteractionEvent) {
            tempImporter.registerInteractionEventCallback(onInteractionEvent);
        }
        if (onRecordChange || onRecordInit) {
            tempImporter.registerRecordHook(function (record, index, eventType) {
                if (eventType === 'init' && onRecordInit) {
                    return onRecordInit(record, index);
                }
                if (eventType === 'change' && onRecordChange) {
                    return onRecordChange(record, index);
                }
            });
        }
        importerRef.current = tempImporter;
        setLoaded(true);
    };
    react_1.useEffect(function () {
        if (preload) {
            loadImporter();
        }
    }, []);
    var dataHandler = react_1.useCallback(function (results) {
        var _a;
        (_a = importerRef.current) === null || _a === void 0 ? void 0 : _a.displayLoader();
        onData === null || onData === void 0 ? void 0 : onData(results).then(function (optionalMessage) {
            var _a, _b;
            return optionalMessage !== null
                ? (_a = importerRef.current) === null || _a === void 0 ? void 0 : _a.displaySuccess(optionalMessage || undefined) : (_b = importerRef.current) === null || _b === void 0 ? void 0 : _b.close();
        }, function (error) { var _a; return (_a = importerRef.current) === null || _a === void 0 ? void 0 : _a.requestCorrectionsFromUser(error instanceof Error ? error.message : error).then(dataHandler, function () { return onCancel === null || onCancel === void 0 ? void 0 : onCancel(); }); });
    }, [onData, onCancel]);
    var launch = function () {
        var _a;
        if (!importerRef.current) {
            if (preload) {
                return;
            }
            loadImporter();
        }
        (_a = importerRef.current) === null || _a === void 0 ? void 0 : _a.requestDataFromUser({ source: source }).then(dataHandler, function () { return onCancel === null || onCancel === void 0 ? void 0 : onCancel(); });
    };
    if (!loaded && preload) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return render ? (render(importerRef.current, launch)) : (react_1.default.createElement("button", __assign({}, props, { onClick: launch }), children));
};
exports.default = FlatfileButton;
//# sourceMappingURL=FlatFileButton.js.map